export const animeEmptyValueMessages = {
  items: 'No anime found.',
  synopsis: 'No synopsis available for this anime.',
  background: 'No background information available for this anime.',
  scoreStats: 'No score data available for this anime.',
  staff: 'No staff information available for this anime.',
  producers: 'No producers listed for this anime.',
  characters: 'No characters available for this anime.',
  episodes: 'No episode information available for this anime.',
  streaming: 'No streaming information available for this anime.',
  relations: 'No related anime found.',
  news: 'No news available for this anime.',
  recommendations: 'No recommendations available for this anime.',
  pictures: 'No pictures available for this anime.',
  videos: {
    promotion: 'No promotional videos available for this anime.',
    music: 'No music videos available for this anime.',
  },
  newEpisodes: 'No new episodes available for this day.',
  seasonal: 'No anime available for this season.',
};

export const mangaEmptyValueMessages = {
  items: 'No manga found.',
  synopsis: 'No synopsis available for this manga.',
  background: 'No background information available for this manga.',
  scoreStats: 'No score data available for this manga.',
  producers: 'No producers listed for this manga.',
  characters: 'No characters available for this manga.',
  relations: 'No related manga found.',
  news: 'No news available for this manga.',
  recommendations: 'No recommendations available for this manga.',
  pictures: 'No pictures available for this manga.',
};

export const characterEmptyValueMessages = {
  about: 'No information available about this character.',
  pictures: 'No pictures available for this character.',
  anime: 'No anime appearances available for this character.',
  manga: 'No manga appearances available for this character.',
  voices: 'No voice actors listed for this character.',
};

export const personEmptyValueMessages = {
  about: 'No information available about this person.',
  pictures: 'No pictures available for this person.',
  anime: 'No anime appearances available for this person.',
  manga: 'No manga appearances available for this person.',
  voices: 'No voice acting roles available for this person.',
};

export const producerEmptyValueMessages = {
  about: 'No information available about this producer.',
};

export const commonMessages = {
  error: 'Failed to fetch data from the server. Please try again later.',
};
